<template>
  <div class="card shadow-sm mb-4">
    <div class="card-body px-4 pt-3 pb-2">
      <BaseDataTable
        :loading="loading"
        :items="items"
        :columns="columns"
        :total="total"
        :rowKey="rowKey"
        :colgroup="colgroup"
        empty-message="조건에 맞는 이벤트가 없습니다."
        :usePaging="false"
        :minBodyHeight="heights.minBody"
        :minContHeight="heights.minCont"
        :message="'이벤트 검색중...'"
        @row-click="onRowClick"
        :minHeight="heights.min"
        :emptyHeight="heights.empty"
      >
        <template #row="{ item, index }">
          <!-- No. -->
          <td class="text-center text-sm">{{ total - startIndex - index }}</td>

          <!-- 시간 -->
          <td class="text-center text-sm" :title="item.eventTime">
            {{ fmtTime(item.eventTime) }}
          </td>

          <!-- 이벤트ID -->
          <td class="text-center text-sm" :title="item.eventID">
            <!-- <soft-badge size="sm" color="info" variant="gradient">{{ item.eventID }}</soft-badge> -->
            <CustomBadge level="very-high" size="sm" :label="item.eventID" />
          </td>

          <!-- 타입/액션 -->
          <td class="text-center text-sm">
            <CustomBadge level="high" size="sm" :label="item.eventType" />
            <CustomBadge v-if="item.action"  :level="badgeColor(item.action)" size="sm" :label="item.action" class="ms-1"/>
            <!-- <soft-badge size="sm" color="info" variant="gradient">{{ item.eventType }}</soft-badge>
            <soft-badge v-if="item.action" size="sm" class="ms-1" :color="badgeColor(item.action)" variant="gradient">
              {{ (item.action || '').toUpperCase() }}
            </soft-badge> -->
          </td>

          <!-- bizStep / disposition -->
          <td class="text-center text-sm">
            <CustomBadge level="low" size="sm" :label="item.bizStep" />
            <CustomBadge level="low" size="sm" :label="item.disposition" class="ms-1"/>
            <!-- <soft-badge size="sm" color="info" variant="gradient">{{ item.bizStep }}</soft-badge>
            <soft-badge size="sm" class="ms-1" color="info" variant="gradient">{{ item.disposition }}</soft-badge> -->
          </td>

          <!-- 대상(EPC/수량) -->
          <!-- <td class="text-start text-sm">
            <div v-if="item.epcList?.length">
              <span class="d-block text-sm" :title="item.epcList[0]">{{ item.epcList[0] }}</span>
              <small v-if="item.epcList.length > 1" class="text-secondary">
                외 {{ item.epcList.length - 1 }}개
              </small>
            </div>
            <div v-else-if="item.quantityList?.length">
              <span class="fw-600">{{ item.quantityList[0]?.epcClass }}</span>
              <small class="ms-1">x {{ item.quantityList[0]?.quantity }}</small>
              <small v-if="item.quantityList.length > 1" class="text-secondary">
                외 {{ item.quantityList.length - 1 }}개
              </small>
            </div>
            <div v-else class="text-secondary">-</div>
          </td> -->

          <!-- 위치 -->
          <!-- <td class="text-start text-sm">
            <div class="text-truncate" :title="item.readPoint">{{ shortId(item.readPoint) }}</div>
            <div class="text-secondary text-truncate" :title="item.bizLocation">{{ shortId(item.bizLocation) }}</div>
          </td> -->

          <!-- 컨텍스트 -->
          <!-- <td class="text-start text-sm">
            <div v-if="item.parentID">
              <small class="text-secondary">parent</small>
              <code class="d-block text-truncate" :title="item.parentID">{{ shortId(item.parentID) }}</code>
            </div>
            <div v-if="item.transactionList?.length">
              <small class="text-secondary">txn</small>
              <code class="d-block text-truncate" :title="item.transactionList[0]">{{ shortId(item.transactionList[0]) }}</code>
            </div>
            <div v-if="item.sourceList?.length || item.destinationList?.length">
              <small class="text-secondary">flow</small>
              <span class="d-block text-truncate"
                    :title="fmtFlow(item)">{{ fmtFlow(item) }}</span>
            </div>
            <div v-if="!item.parentID && !item.transactionList?.length && !(item.sourceList?.length || item.destinationList?.length)"
                 class="text-secondary">-</div>
          </td> -->
        </template>
      </BaseDataTable>
    </div>
  </div>
</template>

<script>
import CustomBadge from '@/components/CustomBadge.vue';
import BaseDataTable from '@/components/BaseDataTable.vue';
import SoftBadge from "@/components/SoftBadge.vue";
import api from '@/api/api';

export default {
  name: "EventTable",
  components: { CustomBadge, BaseDataTable, SoftBadge },
  props: {
    filters: { type: Object, default: () => ({}) },
    applyTick: { type: Number, default: 0 },
    initPageSize: { type: Number, default: 50 }, 
    heights: {type: Object, default: () => ({
      minBody: 680,
      minCont: 680,
      min: 800,
      empty: 650,
    })}
  },
  emits: ['row-click', 'update-stats'],
  data() {
    return {
      loading: false,
      items: [],
      total: 0,
      page: 1,
      pageSize: this.initPageSize,
      sort: 'eventTime,desc',
      columns: [
        { label: 'No.' },
        { label: '이벤트시간', sortable: true, prop: 'eventTime' },
        { label: '이벤트ID', sortable: true, prop: 'eventID' },
        { label: '타입/액션', sortable: true, prop: 'eventType' },
        { label: '업무/상태', prop: 'bizStep' },
        //{ label: '대상(EPC)' },
        //{ label: '위치' },
        //{ label: '컨텍스트' },
      ],
      colgroup: [
        'width:8%',
        'width:20%',
        'width:32%',
        'width:20%',
        'width:20%',
        //'width:18%',
        //'width:10%',
      ],
    };
  },
  computed: {
    startIndex() { return (this.page - 1) * this.pageSize; },
  },
  watch: {
    applyTick() { this.page = 1; this.fetch(); },
    page() { this.fetch(); },
    pageSize() { this.page = 1; this.fetch(); },
  },
  mounted() { 

  },
  methods: {
    rowKey(item, idx) { return item.eventID || idx; },
    async fetch() {
      this.loading = true;
      const start = performance.now();
      try {
        const mfId = this.$store.getters['UserStore/getMfId'];
        const params = {
          mfId,
          page: this.page,
          size: this.pageSize,
          sort: this.sort,
          eventTypes: this.filters.eventTypes?.join(','),
          actions: this.filters.actions?.join(','),
          bizSteps: this.filters.bizSteps?.join(','),
          dispositions: this.filters.dispositions?.join(','),
          epc: this.filters.epc || '',
          gtin: this.filters.gtin || '',
          serial: this.filters.serial || '',
          timeFrom: this.filters.timeFrom || '',
          timeTo: this.filters.timeTo || '',
          category: this.filters.category || '',
        };

        const [res] = await Promise.all([
          api.get('/event/page', { params }),
          new Promise(r => setTimeout(r, 400)) // 로딩 최소 유지
        ]);
        const end = performance.now();
        this.elapsed = ((end - start) / 1000).toFixed(2);

        const r = res.data?.result?.eventList || {};
        this.items = r.items || [];
        this.total = Number(r.total || 0);
        this.$emit('update-stats', { total: this.total, elapsed: this.elapsed });

      } catch (e) {
        console.error('EPCIS 이벤트 조회 실패:', e);
        // toastError('EPCIS 이벤트 조회 실패'); // 전역 토스트 사용 시
      } finally {
        this.loading = false;
      }
    },
    onRowClick(item) { this.$emit('row-click', item); },
    // ---------- 표시 헬퍼 ----------
    fmtTime(str) {
      if (!str) return '-';
      const d = new Date(str);
      if (isNaN(d)) return str;
      // 로컬 포맷 (초 미포함)
      return d.toLocaleString(undefined, { year:'2-digit', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit' });
    },
    shortId(v='') {
      if (!v) return '';
      // urn, gln 길면 중간 생략 (변경 가능)
      return v.length > 26 ? `${v.slice(0,12)}…${v.slice(-10)}` : v;
    },
    badgeColor(action) {
      if (!action) return '';        // null/''면 무채색
      const a = String(action).toUpperCase(); // 안전하게 문자열화
      if (a === 'ADD') return 'medium';
      if (a === 'DELETE') return 'high';
      if (a === 'OBSERVE' || a === 'OBSERVED') return 'very-high';
      return 'secondary';
    },
    fmtFlow(item) {
      const src = item.sourceList?.[0];
      const dst = item.destinationList?.[0];
      if (src && dst) return `${this.shortId(src)} → ${this.shortId(dst)}`;
      if (src) return `from ${this.shortId(src)}`;
      if (dst) return `to ${this.shortId(dst)}`;
      return '';
    },
  }
};
</script>
